<template>
  <div :dir="$functions.currentLangDirection()"
    style="width: 100vw;
            height: 100vh;
            padding: 0px !important;
            margin: 0px !important;
            top: 62px !important;
            left: 0px !important;
            position: absolute;overflow-y: auto;
padding-bottom: 50px !important;"
  >
    <div
      class="card  d-md-block"
      style="overflow-x: hidden; margin: 8px;"
    >
      <b-card-body style="background: #fff;margin: 5px;">
        <b-row>
          <b-col cols="6">
            <v-icon
              size="22"
              color="rgb(50 179 241 / 83%)"
            >mdi-format-title</v-icon>
            <span class="titleSpan">{{ $t('Car name') }}</span>
          </b-col>
          <b-col
            cols="6"
            style="text-align: left;"
          >
            <v-icon
              size="16"
              color="rgba(241, 122, 50, 0.83)"
              @click="onEditItem('modal-change-name', deviceInfo)"
            >
              mdi-pencil
            </v-icon>
            {{ deviceInfo.title }}
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col cols="6">
            <v-icon
              size="22"
              color="rgb(50 179 241 / 83%)"
            >mdi-tag-multiple</v-icon>
             <span class="titleSpan">{{ $t('Device model') }}</span>
          </b-col>
          <b-col
            cols="6"
            style="text-align: left;"
          >
            {{ deviceInfo.modelId ? deviceInfo.modelId.title : '' }}
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col cols="6">
            <v-icon
              size="22"
              color="rgb(50 179 241 / 83%)"
            >mdi-view-week-outline</v-icon>
            <span class="titleSpan">{{ $t('Device serial') }}</span>
          </b-col>
          <b-col
            cols="6"
            style="text-align: left;"
          >
            {{ deviceInfo.imei }}
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col cols="6">
            <v-icon
              size="22"
              color="rgb(50 179 241 / 83%)"
            >mdi-clock-time-three-outline</v-icon>
            <span class="titleSpan">{{ $t('Expiration date') }}</span>
          </b-col>
          <b-col
            cols="6"
            style="text-align: left;"
          >
            {{ deviceInfo.expireTime }}
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col cols="6">
            <v-icon
              style="transform: rotate(-90deg);"
              size="22"
              color="rgb(50 179 241 / 83%)"
            >mdi-sim-outline</v-icon>
            <span class="titleSpan">{{ $t('Sim') }}</span>
          </b-col>
          <b-col
            cols="6"
            style="text-align: left;"
          >
            <v-icon
              size="16"
              color="rgba(241, 122, 50, 0.83)"
              @click="onEditItem('modal-change-sim', deviceInfo)"
            >
              mdi-pencil
            </v-icon>
            {{ deviceInfo.sim }}
          </b-col>
        </b-row>

      </b-card-body>
    </div>
    <div
      class="card  d-md-block"
      style="overflow-x: hidden; margin: 8px;"
    >
      <b-card-body style="background: #fff;margin: 5px;">
        <b-row>
          <b-col cols="6">
            <v-icon
              size="22"
              color="rgb(50 179 241 / 83%)"

            >mdi-source-commit-start</v-icon>
            <span class="titleSpan">{{ $t('Start alarm') }}</span>
          </b-col>
          <b-col
            cols="6"
            style=""
          >
            <b-form-checkbox
              v-model="notificationSettings.ignition"
              name="check-button"
              :dir="$functions.currentLangDirection()"
              switch
              size="xl"
              style="vertical-align: top;direction: rtl;text-align: right"
              @change="onSetNotificationSettings()"
            />
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col cols="6">
            <v-icon
              size="22"
              color="rgb(50 179 241 / 83%)"
            >mdi-battery-charging-low</v-icon>
            <span class="titleSpan">{{ $t('Battery alarm') }}</span>
          </b-col>
          <b-col
            cols="6"
            style="text-align: left;"
          >
            <b-form-checkbox
              v-model="notificationSettings.charging"
              name="check-button"
              switch
              size="xl"
              style="vertical-align: top;direction: rtl;text-align: right;"
              @change="onSetNotificationSettings()"
            />
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col cols="6">
            <v-icon
              size="22"
              color="rgb(50 179 241 / 83%)"
            >mdi-speedometer</v-icon>
            <span class="titleSpan">{{ $t('Battery speed') }}</span>
          </b-col>
          <b-col
            cols="6"
            style="text-align: left;"
          >
            <b-form-checkbox
              v-model="notificationSettings.switchSpeed"
              name="check-button"
              switch
              size="xl"
              style="vertical-align: top;direction: rtl;text-align: right"
              @change="onSetNotificationSettings()"
            />
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col cols="6">
            <v-icon
              style="transform: rotate(0deg);"
              size="22"
              color="rgb(50 179 241 / 83%)"
            >mdi-car-brake-alert</v-icon>
            <span class="titleSpan">{{ $t('Crane handling alarm') }}</span>
          </b-col>
          <b-col
            cols="6"
            style="text-align: left;"
          >
            <b-form-checkbox
              v-model="notificationSettings.gpsTracking"
              name="check-button"
              switch
              size="xl"
              style="vertical-align: top;direction: rtl;text-align: right"
              @change="onSetNotificationSettings()"
            />
          </b-col>
        </b-row>

      </b-card-body>
    </div>
    <div
      class="card  d-md-block"
      style="overflow-x: hidden;margin: 8px;"
    >
      <b-card-body style="background: #fff;margin: 5px;">
        <b-row>
          <b-col cols="6">
            <v-icon
              size="22"
              color="rgb(50 179 241 / 83%)"
            >mdi-format-title</v-icon>
            <span class="titleSpan">{{ $t('Status') }}</span>
          </b-col>
          <b-col
            cols="6"
            style="text-align: left;"
          >
            <span v-if="deviceInfo.onlineStatus==='onlineSymbol'">{{ $t('Online') }}</span>
            <span v-else>{{ $t('Offline') }}</span>
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col cols="6">
            <v-icon
              size="22"
              color="rgb(50 179 241 / 83%)"
            >mdi-tag-multiple</v-icon>
            <span class="titleSpan">ACC</span>
          </b-col>
          <b-col
            cols="6"
            style="text-align: left;"
          >
            <span v-if="deviceInfo.serverStatus && deviceInfo.serverStatus.terminalInfo && deviceInfo.serverStatus.terminalInfo.ignition">ON</span>
            <span v-else>OFF</span>
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col cols="7">
            <v-icon
              size="22"
              color="rgb(50 179 241 / 83%)"
            >mdi-view-week-outline</v-icon>
            <span class="titleSpan">{{ $t('Location update') }}</span>
          </b-col>
          <b-col
            cols="5"
            style="text-align: left;"
          >
            {{ deviceInfo.serverStatus ? timeHistory(deviceInfo.serverStatus.servertime) : '' }}
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col cols="6">
            <v-icon
              style="transform: rotate(-90deg);"
              size="22"
              color="rgb(50 179 241 / 83%)"
            >mdi-sim-outline</v-icon>
            <span class="titleSpan">{{ $t('Status update') }}</span>
          </b-col>
          <b-col
            cols="6"
            style="text-align: left;"
          >
            <span v-if="deviceInfo.serverStatus && deviceInfo.serverStatus.terminalInfo && deviceInfo.serverStatus.terminalInfo.ignitionChangeTime">
              {{ timeHistory(deviceInfo.serverStatus.terminalInfo.ignitionChangeTime) }}
            </span>
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col cols="6">
            <v-icon
              style="transform: rotate(-90deg);"
              size="22"
              color="rgb(50 179 241 / 83%)"
            >mdi-speedometer</v-icon>
            <span class="titleSpan">{{ $t('Speed') }}</span>
          </b-col>
          <b-col
            cols="6"
            style="text-align: left;"
          >
            {{ deviceInfo.speed }}
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col cols="6">
            <v-icon
              style="transform: rotate(-90deg);"
              size="22"
              color="rgb(50 179 241 / 83%)"
            >mdi-map</v-icon>
            <span class="titleSpan">{{ $t('Longitude') }}</span>
          </b-col>
          <b-col
            cols="6"
            style="text-align: left;"
          >
            {{ deviceInfo.serverInfo && deviceInfo.serverInfo.latitude ? (deviceInfo.serverInfo.latitude.$numberDecimal || deviceInfo.serverInfo.latitude) : (deviceInfo.serverInfo && deviceInfo.serverInfo.lat ? deviceInfo.serverInfo.lat : '0') }}
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col cols="6">
            <v-icon
              style="transform: rotate(-90deg);"
              size="22"
              color="rgb(50 179 241 / 83%)"
            >mdi-map</v-icon>
            <span class="titleSpan">{{ $t('Latitude') }}</span>
          </b-col>
          <b-col
            cols="6"
            style="text-align: left;"
          >
            {{ deviceInfo.serverInfo && deviceInfo.serverInfo.longitude ? (deviceInfo.serverInfo.longitude.$numberDecimal || deviceInfo.serverInfo.longitude) : (deviceInfo.serverInfo && deviceInfo.serverInfo.lon ? deviceInfo.serverInfo.lon : '0') }}
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col cols="6">
            <v-icon
              style="transform: rotate(-90deg);"
              size="22"
              color="rgb(50 179 241 / 83%)"
            >mdi-map-marker</v-icon>
            <span class="titleSpan">{{ $t('Address') }}</span>
          </b-col>
          <b-col
            cols="6"
            style="text-align: left;"
          >
            {{ address }}
          </b-col>
        </b-row>

      </b-card-body>
    </div>
    <b-modal
      ref="modal-change-sim"
      cancel-variant="outline-secondary"
      :ok-title="$t('Save')"
      :cancel-title="$t('Close')"
      centered
      :title="$t('Change the sim')"
      :dir="$functions.currentLangDirection()"
    >
      <b-form>
        <b-form-group
          :label="$t('Current sim number')"
          label-for="v-Sim"
        >
          <b-form-input
            id="v-Sim"
            v-model="device.sim"
            class="numeric-input"
            maxlength="11"
            disabled
          />
        </b-form-group>
        <b-form-group
          :label="$t('New sim number')"
          label-for="v-Sim"
        >
          <b-form-input
            id="v-Sim"
            v-model="simIdSelected"
            placeholder="09xxxxxxxxx"
            maxlength="11"
            class="numeric-input"
          />
        </b-form-group>
      </b-form>
      <template #modal-footer="">
        <b-button
          size="sm"
          variant="danger"
          @click="hideModal('modal-change-sim')"
        >
          {{ $t('Close') }}
        </b-button>
        <b-button
          size="sm"
          variant="success"
          @click="modalChangeSim()"
        >
          {{ $t('Save') }}
        </b-button>
      </template>
    </b-modal>

    <b-modal
      ref="modal-change-name"
      cancel-variant="outline-secondary"
      :ok-title="$t('Save')"
      :cancel-title="$t('Close')"
      centered
      :dir="$functions.currentLangDirection()"
      :title="$t('Change the name of the car')"
    >
      <b-form>
        <b-form-group
          :label="$t('Current name')"
          label-for="v-title"
        >
          <b-form-input
            id="v-title"
            v-model="device.title"
            disabled
          />
        </b-form-group>
        <b-form-group
          :label="$t('New name')"
          label-for="v-Sim"
        >
          <b-form-input
            id="v-Sim"
            v-model="newtitle"
            maxlength="100"
          />
        </b-form-group>
      </b-form>
      <template #modal-footer="">
        <b-button
          size="sm"
          variant="danger"
          @click="hideModal('modal-change-name')"
        >
          {{ $t('Close') }}
        </b-button>
        <b-button
          size="sm"
          variant="success"
          @click="modalChangeTitle()"
        >
          {{ $t('Save') }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import {
  BLink, BButton, BCard, BCardText, BCardBody, BRow, BCol, BFormCheckbox, BForm, BFormGroup, BFormInput,
} from 'bootstrap-vue'
import Vue from 'vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import PreLoaderSpinner from '@core/components/pre-loader-spinner/PreLoaderSpinner'
import deviceService from '@/services/device.service'
import Device from '@/models/device'
import moment from 'moment/moment'
// eslint-disable-next-line import/extensions

export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    BLink, BButton, BCard, BCardText, BCardBody, BRow, BCol, BFormCheckbox, BForm, BFormGroup, BFormInput,
  },
  data() {
    return {
      notificationSettings: {
        ignition: true, charging: true, switchSpeed: true, gpsTracking: true,
      },
      address: '',
      sortBy: 'creationTime',
      selectedImei: Vue.prototype.$selectDeviceDetail,
      deviceInfo: {
        serverStatus: {
          terminalInfo: {
            ignition: false,
            charging: false,
            gpsTracking: false,
            ignitionChangeTime: null,
          },
          servertime: 0,
        },
        serverInfo: {
          latitude: { $numberDecimal: '0' },
          longitude: { $numberDecimal: '0' },
        },
        onlineStatus: 'offline',
        modelId: { title: '' },
      },
      device: new Device('', '', '', '', '', '', '', '', '', ''),
      newtitle: '',
      simIdSelected: '',
    }
  },
  computed: {
    // واکنشی کردن selectedImei برای آپدیت خودکار
    currentImei() {
      return Vue.prototype.$selectDeviceDetail
    },
  },
  watch: {
    // وقتی imei تغییر کرد، داده‌ها رو آپدیت کن
    currentImei: {
      handler(newImei) {
        if (newImei && newImei !== 0) {
          this.selectedImei = newImei
          this.loadDetail()
          this.getServerDeviceStatusAndSettings()
        }
      },
      immediate: true,
    },
  },
  created() {
    this.initDeviceInfo()
  },
  mounted() {
    this.initDeviceInfo()
    // اگر imei معتبر بود، داده‌ها رو لود کن
    if (this.selectedImei && this.selectedImei !== 0) {
      this.loadDetail()
      this.getServerDeviceStatusAndSettings()
    }
  },
  methods: {
    initDeviceInfo() {
      const imei = Vue.prototype.$selectDeviceDetail
      if (imei && imei !== 0) {
        this.selectedImei = imei
        const info = Vue.prototype.$functions.getDeviceInfo(imei)
        if (info) {
          this.deviceInfo = Vue.prototype.$functions.fixDeviceInfo(info)
        }
      }
    },
    async loadDetail() {
      const info = Vue.prototype.$functions.getDeviceInfo(this.selectedImei)
      if (info === null || !this.selectedImei) return
      Vue.prototype.$functions.setMobileSelectedDevices([this.selectedImei])
      this.deviceInfo = Vue.prototype.$functions.fixDeviceInfo(info)
      if (this.deviceInfo.serverInfo) {
        const coords = Vue.prototype.$functions.getLatLngFromServerInfo(this.deviceInfo.serverInfo)
        if (coords) {
          this.address = await Vue.prototype.$functions.getFullAddress({
            latitude: coords.lat,
            longitude: coords.lng,
          }, this.selectedImei)
        }
      }
    },
    doFillDevices() {
      Vue.prototype.$functions.fillDevices().then(() => {
        this.$forceUpdate()
      })
    },
    onSetNotificationSettings() {
      const data = {
        imei: this.selectedImei,
        data: this.notificationSettings,
      }
      deviceService.notificationSettings(data).then(
        res => {
          if (res.status === 'success') {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$t('Message'),
                text: this.$t('The operation was successful'),
                icon: 'XIcon',
                variant: 'success',
                dir: Vue.prototype.$functions.currentLangDirection(),
              },
            })
          }
        },
        error => {
          this.message = (error.response && error.response.data)
                || error.message
                || error.toString()
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('Error'),
              text: this.message,
              icon: 'XIcon',
              variant: 'danger',
              dir: Vue.prototype.$functions.currentLangDirection(),
            },
          })
        },
      )
    },
    getServerDeviceStatusAndSettings() {
      // اگر imei معتبر نیست، درخواست نفرست
      if (!this.selectedImei || this.selectedImei === 0) {
        PreLoaderSpinner.methods.hide()
        return
      }
      deviceService.getServerDeviceStatusAndSettings({ imei: this.selectedImei }).then(
        resp => {
          if (resp.status === 'success') {
            if ('result' in resp) {
              const { data } = resp.result
              if (data) {
                const index = Vue.prototype.$functions.getDeviceIndex(data.imei)
                if (index !== -1 && index !== null) {
                  if ('lastStatus' in data) {
                    Vue.prototype.$devices[index].serverStatus = data.lastStatus
                  }
                  if ('notificationSettings' in data) {
                    Vue.prototype.$devices[index].notificationSettings = data.notificationSettings
                    this.notificationSettings = data.notificationSettings
                  }
                  // آپدیت deviceInfo محلی با داده‌های جدید
                  const info = Vue.prototype.$functions.getDeviceInfo(this.selectedImei)
                  if (info) {
                    this.deviceInfo = Vue.prototype.$functions.fixDeviceInfo(info)
                  }
                }
              }
              // بخاطر انیمیشن برخی آبجکتها 300 میلی ثانیه صبر میکنیم
              setTimeout(() => {
                PreLoaderSpinner.methods.hide()
                Vue.prototype.$pagesInitializeData.DeviceDashboardVue.firstLoaded = false
              }, 300)
            }
          }
        },
      )
    },
    getDeviceOnlineStatusCssClass(imei) {
      return Vue.prototype.$devices[Vue.prototype.$functions.getDeviceIndex(imei)].onlineStatus
    },
    getPopupInfo(index) {
      if (typeof index === 'undefined') {
        return false
      }
      return Vue.prototype.$functions.fixDeviceInfo(Vue.prototype.$functions.getDeviceInfo(index))
    },
    doFillAlarm(imei) {
      this.desserts = []
      const imeis = []

      if (imei !== null) {
        imeis.push(imei)
      } else {
        const BreakException = {}
        try {
          Vue.prototype.$devices.forEach((devices, index) => {
            imeis.push(devices.imei)
            if (index === 20) throw BreakException
          })
        } catch (e) {
          if (e !== BreakException) throw e
        }
      }
    },
    timeHistory(unixTime) {
      // بررسی مقادیر نامعتبر
      if (!unixTime || unixTime < 1000) return ''
      if (this.$t('lang') === 'fa') {
        return Vue.prototype.$functions.toFaNumbers(this.$functions.unixToPersianDate(unixTime))
      }
      return moment.unix(unixTime).format('DD-MM-YYYY HH:mm:ss')
    },
    sinceFrom(unixTime) {
      if (!unixTime || unixTime < 1000) {
        return this.$t('Unknown')
      }
      const time = Vue.prototype.$functions.time()
      return this.$functions.timeSince(unixTime > time ? time : unixTime)
    },

    modalChangeSim() {
      // eslint-disable-next-line no-underscore-dangle,radix
      deviceService.changeSim({ imei: parseInt(this.device.imei), sim: this.simIdSelected }).then(
        res => {
          if (res.status === 'success') {
            this.$refs['modal-change-sim'].hide()
            this.doFillDevices()
          }
        },
        error => {
          this.message = (error.response && error.response.data)
                || error.message
                || error.toString()
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'error',
              text: this.message,
              icon: 'XIcon',
              variant: 'danger',
            },
          })
        },
      )
    },
    modalSendSms() {
      if (Vue.prototype.$productionPlatform === 'ios') {
        window.location.href = `sms://${this.device.sim}&body=${this.smsconfigtext}`
      } else if (Vue.prototype.$productionPlatform === 'android') {
        window.location.href = `sms:${this.device.sim}?body=${this.smsconfigtext}`
      //  window.location.href = `http://127.0.0.1:3232/QXNative/?action=openSmsManager&to=${this.device.sim}&body=${encodeURIComponent(this.smsconfigtext)}`
      }
    },
    modalChangeTitle() {
      // eslint-disable-next-line no-underscore-dangle,radix
      deviceService.changeTitle({ imei: parseInt(this.device.imei), title: this.newtitle, category: this.device.category }).then(
        res => {
          if (res.status === 'success') {
            this.$refs['modal-change-name'].hide()
            this.doFillDevices()
          }
        },
        error => {
          this.message = (error.response && error.response.data)
                || error.message
                || error.toString()
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'error',
              text: this.message,
              icon: 'XIcon',
              variant: 'danger',
            },
          })
        },
      )
    },
    modalChangeCategory() {
      // eslint-disable-next-line no-underscore-dangle,radix
      deviceService.changeTitle({ imei: parseInt(this.device.imei), title: this.device.title, category: this.device.category }).then(
        res => {
          if (res.status === 'success') {
            this.$refs['modal-change-category'].hide()
            this.doFillDevices()
          }
        },
        error => {
          this.message = (error.response && error.response.data)
                || error.message
                || error.toString()
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'error',
              text: this.message,
              icon: 'XIcon',
              variant: 'danger',
            },
          })
        },
      )
    },
    hideModal(action) {
      if (action === 'modal-change-sim') {
        this.$refs['modal-change-sim'].hide()
      }
      if (action === 'modal-change-name') {
        this.$refs['modal-change-name'].hide()
      }
      if (action === 'modal-change-category') {
        this.$refs['modal-change-category'].hide()
      }
      if (action === 'modal-send-sms') {
        this.$refs['modal-send-sms'].hide()
      }
    },
    onEditItem(action, item) {
      if (action === 'modal-change-sim') {
        this.device.sim = item.sim.toString()
        this.device.imei = item.imei.toString()
        // eslint-disable-next-line no-underscore-dangle
        this.device.modelId = item.modelId._id.toString()
        this.$refs['modal-change-sim'].show()
      }
      if (action === 'modal-change-name') {
        this.device.title = item.title.toString()
        this.device.category = item.category
        this.device.imei = item.imei.toString()
        // eslint-disable-next-line no-underscore-dangle
        this.device.modelId = item.modelId._id.toString()
        this.$refs['modal-change-name'].show()
      }
      if (action === 'modal-change-category') {
        this.device.title = item.title.toString()
        this.device.category = item.category
        this.device.imei = item.imei.toString()
        // eslint-disable-next-line no-underscore-dangle
        this.device.modelId = item.modelId._id.toString()
        this.$refs['modal-change-category'].show()
      }
      if (action === 'modal-send-sms') {
        this.device.sim = item.sim
        this.device.title = item.title.toString()
        this.device.imei = item.imei.toString()
        // eslint-disable-next-line no-underscore-dangle
        this.device.modelId = item.modelId._id.toString()
        this.$refs['modal-send-sms'].show()
      }
    },
  },
}
</script>
<style>
.theme--light.v-pagination .v-pagination__item--active{
  font-weight: bold;
  color: #2077ff;
}

[dir=rtl] .titleSpan{
  color: #222;
  padding-right: 5px;
}

[dir] .custom-control-input:checked ~ .custom-control-label::before {
  border-color: #0c95d7;background-color: #0c95d7;
}

[dir=ltr] .v-icon {
  margin-right: 7px;
}
</style>
